import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MultiLanguageManagementService } from '../../multi-language-management.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NbToastrService } from '@nebular/theme';
import { TblActionType } from 'src/app/shared/enums/tbl-action-type.enum';
import { TranslationPanelComponent } from 'src/app/shared/components/translation-panel/translation-panel.component';

@Component({
  selector: 'app-add-edit-translate',
  templateUrl: './add-edit-translate.component.html',
  styleUrls: ['./add-edit-translate.component.scss']
})
export class AddEditTranslateComponent implements OnInit,AfterViewInit {

  @ViewChild('appTranslationPanel', { static: true }) appTranslationPanel: TranslationPanelComponent;

  referenceType: string;
  referenceId: string;
  referenceRevisionId: number;
  action: TblActionType;
  TblActionType = TblActionType;
  selectedLanguage: string = 'es'; // Default to Spanish
  previousLanguage: string = 'es';

  constructor(
    private multiLanguageService: MultiLanguageManagementService,
    public dialogRef: MatDialogRef<AddEditTranslateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: NbToastrService,
  ) 
  {
    //Action will be Add Or Edit, if it is Action Add => We eliminate all the languague that has been translated
    this.action = this.data?.action ?? this.action;
    this.referenceType = this.data?.model?.objName ?? this.referenceType;

    if (this.referenceType.toLowerCase() === "CategoryLocation".toLowerCase()) {
      this.referenceType = "CATEGORY"; // keep reference type is parent type
      this.data.model.overrideRefId = this.data.model.objId;
      this.data.model.overrideRefType = "CategoryLocation";
    }

    //We receive from primasToolBar or primasTable
    this.referenceId = this.data?.model?.objId ?? this.referenceId;
    if (this.action === TblActionType.Edit) {
      this.referenceRevisionId = this.data?.addtionalData?.revisionId ?? this.referenceRevisionId
    }
    else {
      this.referenceRevisionId = this.data?.model?.revisionId ?? this.referenceRevisionId;
    }

    if (this.data?.model?.objName === "LOCATION") {
      this.referenceRevisionId = parseInt(this.referenceId);
    }    

    //If it has selectedLanguage => that means we are editing
    this.selectedLanguage = this.data?.model?.lang ?? this.selectedLanguage;
    this.previousLanguage = this.selectedLanguage;
  }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.loadEntity();
  }
  get formatReferenceType(): string {
    if (!this.referenceType) return "";
    return this.referenceType.charAt(0).toUpperCase() + this.referenceType.slice(1).toLowerCase();
  }

  async loadEntity() {
    this.appTranslationPanel.isLoadingEntity = true;

    try {
      const resp = await this.multiLanguageService.getEntityByIdAndReference(this.referenceType, this.referenceRevisionId).toPromise();
      
      if (resp.result) {
        await this.appTranslationPanel?.loadFullDetail(resp.result);
        if (this.data?.model?.overrideRefType === 'CategoryLocation')
          await this.appTranslationPanel?.setCategoryLocation(
            this.appTranslationPanel?.locationList?.find(
              l => l.categoryWPLocationId == this.data?.model?.overrideRefId // Check value without type conversion
            ) || null
          );
      }
    } 
    catch (error) {
      this.toast.danger('Error', 'Failed to load entity list');
    } 
    finally {
      this.appTranslationPanel.isLoadingEntity = false;
    }
  }

  async onClickClose(notCheck: boolean) {
    if(notCheck) {
      this.dialogRef.close(false);
    } else {
      const canProceed = await this.appTranslationPanel?.checkUnsavedChanges();
      if (canProceed) {
        this.dialogRef.close(false);
      }
    } 
  }
  // #endregion 
}
